<template>
  <div class="embed">
    <Map
      classString=""
      variable="pct_with_loan"
      :interactive="true"
      legendStyle="below"
      :center="[-74.006, 40.7128]"
      :zoom="8"
      sourceLayer="ppp_full_4"
      sourceURL="mapbox://bellingcat-mapbox.5klcokbi"
      currency="$"
      :ranges="usRanges"
      :interactiveVariables="usInteractiveVariables"
      featureId="zip"
      :zoomStart="8"
      v-if="country == 'us'"
    />
    <Map
      classString=""
      :variable="ukVariable"
      :interactive="true"
      legendStyle="below"
      :center="ukCenter"
      :zoom="ukZoom"
      sourceLayer="UK8"
      sourceURL="mapbox://bellingcat-mapbox.7wb18v24"
      currency="£"
      :ranges="ukRanges"
      :interactiveVariables="ukInteractiveVariables"
      featureId="parliamentary_constituency"
      :zoomStart="6"
      v-if="country == 'uk'"
    />

    <Map
      classString=""
      :variable="'furlough_pct'"
      :interactive="true"
      legendStyle="below"
      :center="[6, 47.227]"
      :zoom="4.8"
      sourceLayer="FR3"
      sourceURL="mapbox://bellingcat-mapbox.9dc436bd"
      currency=""
      :ranges="frRanges"
      :interactiveVariables="frInteractiveVariables"
      featureId="nom"
      :zoomStart="4"
      v-if="country == 'fr'"
    />
  </div>
</template>

<script>
import Map from "../components/Map";
import { variables, interactiveVariables } from "../constants/ranges";
import {
  variables as ukRanges,
  interactiveVariables as ukInteractiveVariables,
} from "../constants/ranges_uk";
import {
  variables as frRanges,
  interactiveVariables as frInteractiveVariables,
} from "../constants/ranges_fr";

export default {
  name: "Embed",
  components: {
    Map,
  },
  props: {
    country: String,
  },
  data() {
    return {
      ukCenter: [-1, 55],
      ukZoom: 5,
      ukVariable: "cjrs",

      usRanges: variables,
      usInteractiveVariables: interactiveVariables,
      ukRanges,
      ukInteractiveVariables,
      frRanges,
      frInteractiveVariables,
    };
  },
  methods: {
    set(center, zoom, variable) {
      this.ukCenter = center;
      this.ukZoom = zoom;
      this.ukVariable = variable;
    },
  },
};
</script>

<style lang="scss" scoped>
.embed {
  height: 100vh;
  width: 100vw;
}
</style>
